import { useMutation, useQueryClient } from "react-query";
import { loggedInApiCall } from "src/api/axiosClient/userApi";

export function useDeleteOrganization() {
    const queryClient = useQueryClient();

    const query = useMutation({
        mutationFn: async (id: number) => {
            const response = await loggedInApiCall.delete("/api/organizations/" + id);
            return response;
        },
        onSuccess: () => queryClient.invalidateQueries(["getAllCompany"], { exact: false }),
    });

    return query;
}
